import { render, staticRenderFns } from "./IQSidePanelShell.vue?vue&type=template&id=583d6f4f&scoped=true"
import script from "./IQSidePanelShell.vue?vue&type=script&setup=true&lang=js"
export * from "./IQSidePanelShell.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQSidePanelShell.vue?vue&type=style&index=0&id=583d6f4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583d6f4f",
  null
  
)

export default component.exports